.multiple-label {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	font-style: italic;
}
